import { css } from '@emotion/react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
export const actionPanelStyles = `
  background-color: ${theme.colors.gray100};
  box-shadow: 0 0 ${styleUtils.rem(6)} 0 rgba(0,0,0,0.3);
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing.x8} ${theme.spacing.x6};
  position: fixed;
  z-index: 9999;
`;
export const closeButtonStyles = css `
  position: absolute;
  right: ${theme.spacing.x4};
  top: ${theme.spacing.x4};
  z-index: 9999;
`;
